import { render, staticRenderFns } from "./MarketPrice.vue?vue&type=template&id=625dd2f8&scoped=true&"
import script from "./MarketPrice.vue?vue&type=script&lang=js&"
export * from "./MarketPrice.vue?vue&type=script&lang=js&"
import style0 from "./MarketPrice.vue?vue&type=style&index=0&id=625dd2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625dd2f8",
  null
  
)

export default component.exports